import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductBreakdown } from './components/ProductBreakdown';
import { WhyChoose } from './components/WhyChoose';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { DetailedTestimonials } from './components/DetailedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    const imgLink = document.createElement('link');
    imgLink.rel = 'preload';
    imgLink.as = 'image';
    imgLink.href = 'https://cdn.magicpatterns.com/uploads/o4RouXz77WZXyquLNbF62G/quimica_box_mobile_optimizada.png';
    document.head.appendChild(imgLink);
  }, []);
  return <main className="w-full min-h-screen bg-sky-100 selection:bg-blue-200 selection:text-blue-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductBreakdown data-id="element-5" />
      <WhyChoose data-id="element-6" />
      <Countdown data-id="element-7" />
      <Pricing data-id="element-8" />
      <DetailedTestimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}